import { AavoMosaic } from "src/components/common/mosaic/AavoMosaic.tsx";
import i18n from "i18next";
import { useRefreshRef } from "src/utils/useRefreshRef.ts";
import { TasksView } from "src/components/views/tasks/TasksView.tsx";
import { useUserData } from "src/contexts/useUserDataContext.ts";

export const TasksOnMyResponsibilityPage = () => {
	const { appUserId } = useUserData();
	const incompleteTasksRefreshRef = useRefreshRef();
	const completedTasksRefreshRef = useRefreshRef();
	return (
		<AavoMosaic
			viewId={"54B95508E67E8FC0"}
			layout={{
				type: "tab",
				items: [
					{
						type: "panel",
						title: i18n.t("incomplete"),
						content: (
							<TasksView
								refreshRef={incompleteTasksRefreshRef}
								onTaskCompleted={() => completedTasksRefreshRef.current?.refresh()}
								taskQueryParams={{
									states: ["RELEASED", "STARTED"],
									responsiblePersonId: appUserId,
								}}
								showResponsiblePerson={false}
							/>
						),
					},
					{
						type: "panel",
						title: i18n.t("completed"),
						content: (
							<TasksView
								refreshRef={completedTasksRefreshRef}
								onTaskCompletionReverted={() =>
									incompleteTasksRefreshRef.current?.refresh()
								}
								taskQueryParams={{
									states: ["COMPLETED"],
									responsiblePersonId: appUserId,
								}}
								showResponsiblePerson={false}
								showGanttButton={false}
							/>
						),
					},
				],
			}}
		/>
	);
};
